import { ComponentPropsWithRef } from "react";
import styled from "styled-components";
import {
  elevation00,
  primary03,
  semanticBlue,
  shade0,
  shade900,
} from "../../styles/tokens";

// TEXT

// STYLES
export const Container = styled.div<ContainerProps>`
  width: ${({ $width = "2rem" }) => $width};
  height: ${({ $height = "2rem" }) => $height};
  border-radius: 100%;
  flex-shrink: 0;
  cursor: ${({ $interactive }) => ($interactive ? "pointer" : "default")};
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $img }) =>
    $img
      ? `
    background-image: url(${$img});
    background-repeat: no-repeat;
    background-size: cover;
  `
      : `
    background-color: ${semanticBlue};
    color: ${shade900};
  `}

  ${({ $interactive }) =>
    $interactive &&
    `
      &:hover {
        outline: 2px solid ${primary03};
        box-shadow: ${elevation00};
      }

      &:focus-visible {
        outline: 1px solid ${shade0};
        outline-offset: 1px;
      }
    `}

  ${({ $open }) =>
    $open &&
    `
      outline: 2px solid ${primary03};
      box-shadow: ${elevation00};
    `}
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithRef<"div"> {
  img?: string | null;
  open?: boolean;
  interactive?: boolean;
  height?: string;
  width?: string;
  user?: { firstName?: string; lastName?: string };
  initials?: string;
}

export type ContainerProps = {
  $img?: string | null;
  $open?: boolean;
  $interactive?: boolean;
  $height?: string;
  $width?: string;
};

// CONSTANTS

// FUNCTIONS
export const getInitials = (firstName = "", lastName = "") =>
  `${firstName[0] ?? ""}${lastName[0] ?? ""}`;

// ASSETS
